export default class DateFormat {

    _format(date) {
        var today = date;
        if (date == null) {
            today = new Date();
        }
        var dd = today.getDate();

        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }

        return { day: dd, month: mm, year: yyyy};
    }

    toDatePicker(date) {
        var today = this._format(date);
        return today.year + '-' + today.month + '-' + today.day;
    }
}


// WEBPACK FOOTER //
// ./src/services/DateFormat.js